import { render, staticRenderFns } from "./appointSingRecord.vue?vue&type=template&id=8618f944&scoped=true"
import script from "./appointSingRecord.vue?vue&type=script&lang=ts"
export * from "./appointSingRecord.vue?vue&type=script&lang=ts"
import style0 from "./appointSingRecord.vue?vue&type=style&index=0&id=8618f944&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8618f944",
  null
  
)

export default component.exports